<template>
  <AnalyzerTable
    :headers="existingManualRatesTableHeaders"
    get-table-data-action="AnalyzerStore/getExistingManualRates"
    table-data-getter="AnalyzerStore/existingManualRates"
  />
</template>

<script>
import AnalyzerTable from "./AnalyzerTable";
import {existingManualRatesTableHeaders} from "@/utils/staticTablesColumns";

export default {
  name: "ExistingManualRates",
  components: {
    AnalyzerTable
  },
  created() {
    this.existingManualRatesTableHeaders = existingManualRatesTableHeaders;
  }
}
</script>

<style scoped>

</style>